import {  t  } from "@/client/libs/dummy-i18n";
import { Input } from "@stackmorph/ui";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";

type TOTPInputProps = {
  onComplete: (code: string) => void;
  error?: string;
};

export const TOTPInput = ({ onComplete, error }: TOTPInputProps) => {
  const [code, setCode] = useState("");
  const [timeLeft, setTimeLeft] = useState(30);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) return 30;
        return prev - 1;
      });
    }, 1000);

    return () => { clearInterval(interval); };
  }, []);

  useEffect(() => {
    if (code.length === 6) {
      onComplete(code);
    }
  }, [code, onComplete]);

  const handleChange = (value: string) => {
    const numericValue = value.replace(/\D/g, "").slice(0, 6);
    setCode(numericValue);
  };

  return (
    <div className="flex flex-col items-center space-y-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="w-full max-w-sm"
      >
        <Input
          autoFocus
          type="text"
          inputMode="numeric"
          maxLength={6}
          value={code}
          placeholder="000000"
          className="text-center text-2xl tracking-widest"
          onChange={(e) => { handleChange(e.target.value); }}
        />
      </motion.div>

      <div className="flex items-center gap-2">
        <div className="h-2 w-32 overflow-hidden rounded-full bg-secondary">
          <motion.div
            className="h-full bg-primary"
            initial={{ width: "100%" }}
            animate={{ width: `${(timeLeft / 30) * 100}%` }}
            transition={{ duration: 1, ease: "linear" }}
          />
        </div>
        <span className="text-sm text-muted-foreground">{timeLeft}s</span>
      </div>

      {error && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="text-sm text-error"
        >
          {error}
        </motion.p>
      )}

      <p className="text-sm text-muted-foreground">
        {t`Enter the 6-digit code from your authenticator app`}
      </p>
    </div>
  );
};
